import { queryKeys } from "@/common/constants/query.constants";
import { apiRoutes } from "@/common/config/configuration";
import { useApiMutationHook } from "@/common/hooks/use-generic-api";
import { ApiRequestMethod } from "../config/api-handler";
import { serviceType } from "@/common/constants/serviceType.constants";
import {
  RefreshTokenRequest,
  RefreshTokenResponse,
} from "../types/authentication.types";

export const useRefreshTokenMutation = () =>
  useApiMutationHook<RefreshTokenRequest, RefreshTokenResponse>(
    queryKeys.authentication.refreshToken,
    `${apiRoutes.organizationManagementService.baseUrl}${apiRoutes.organizationManagementService.authentication.refreshTokenServiceUrl}`,
    ApiRequestMethod.POST,
    serviceType.authentication.refreshToken,
  );
